module.exports = __webpack_public_path__ + "img/12.dirty_mirror.1d980050.svg";